import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { FirestoreService } from '../services/firestore.service';
import { DatePipe } from '@angular/common';
import { Platform } from '@ionic/angular';
import { NotificationsService } from './notifications.service';

@Injectable({
  providedIn: 'root'
})
export class AuthServiceService {

  today: Date = new Date();
  pipe = new DatePipe('en-CO');
  todayWithPipe = null;
  //this.todayWithPipe = this.pipe.transform(Date.now(), 'dd/MM/yyyy');

  referidos: any = [];

  userData: any = [];
  distribuidor:any
  Data:any =[]
  DataPagos:any =[]
  ventas=[];
  Renovaciones: any[];
  Garantias:any [] = [];
  serviciosProblemas: any = [];
  notificacion=0
  notificacionantes=[]
  notificacionesIniciadas = false;

  constructor(public platform: Platform,
              public afsAuth: AngularFireAuth,
              private firestore: AngularFirestore,
              public fireStoreService: FirestoreService,
              private notificaciones: NotificationsService, ) { 

    this.afsAuth.authState.subscribe((user) => {

      if (user) {
        this.firestore.collection('users').doc(user.uid).snapshotChanges().subscribe(res=>{

          this.userData = res.payload.data();
          this.distribuidor=res.payload.data()['distribuidor']

          // Iniciar notificaciones una sola vez, ya con userData cargado
          if (!this.notificacionesIniciadas && this.platform.is('capacitor')) {
            this.notificacionesIniciadas = true;
            this.notificaciones.iniciarNotificaciones();
          }

          this.traerventas(this.userData)
          this.traerReferidos(this.userData.uid)
          this.traerGarantias(this.userData)
          this.traerpagos(this.userData)
          this.traerrenovaciones(this.userData)
          this.traerProblemas(this.distribuidor)

          localStorage.setItem('user', JSON.stringify(this.userData));
          JSON.parse(localStorage.getItem('user')!);
          if(!this.platform.is('capacitor')&& this.userData.notificacion != undefined){

            if(this.userData.notificacion.length < this.notificacion){
              this.notificacion=this.userData.notificacion.length
              const audio = new Audio('../../../assets/sonidos/notificacion.mp3');
              audio.play();
              this.NotificationPC(this.userData.notificacion)
            }
            else{
              this.notificacionantes=this.userData.notificacion
              this.notificacion=this.userData.notificacion.length
            }

            //this.NotificationPC()
          }
        })

      } else {
        this.notificacionesIniciadas = false;   // ← agregar
        localStorage.setItem('user', 'null');
        JSON.parse(localStorage.getItem('user')!);
      }
    });
  }


 async traerventas(user){

    const path = '/users/'+user.uid+'/ventas/';
   // console.log('this.auth.userData.uid',user.uid)
    
    this.fireStoreService.traerDatosVentas(path).subscribe(data => {
      //console.log('this.auth.userData.uid',user.distribuidor)
      this.Data = [];
        data.forEach(element => {
          this.Data.push({
            id: element.payload.doc.id,
            ...element.payload.doc.data()
          })
          if (!this.ventas.find(v => v.id === element.payload.doc.data().servicio)) {
            this.ventas.push({
              id: element.payload.doc.data().servicio,
              servicio: element.payload.doc.data().nombreServicio
            });
          }
      });  
     // console.log('VENTAS', this.Data)
  });  
  }

  traerGarantias(user:any){
  
    const path = 'users/'+user.uid+'/garantias'
    this.fireStoreService.traerDatosGarantias(path).subscribe(res=>{
      this.Garantias=[]
      res.forEach((element: any) => {
        this.Garantias.push({
          idGarantia: element.payload.doc.id, 
          ...element.payload.doc.data(),
        })
      });
    //  console.log('Garantias->',this.Garantias);
    })
  }

  async traerpagos(user){
    const path = '/users/'+user.uid+'/reportedepagos';
    this.firestore.collection(path, ref => ref.orderBy('fecha', 'desc').limit(20)).snapshotChanges().subscribe(data =>{
      this.DataPagos = [];
      data.forEach((element: any) => {
        this.DataPagos.push({
          id: element.payload.doc.id,
          ...element.payload.doc.data()
        })
      });  
     // console.log('PagosReportados->',this.DataPagos);
    })
  }

  async traerrenovaciones(user){
    this.fireStoreService.traerRenovaciones(user.uid).subscribe(data => {
      this.Renovaciones = [];
        data.forEach(element => {
          this.Renovaciones.push({
            idRenovacion: element.payload.doc.id, 
            ...element.payload.doc.data(),
          })

      });  
    //  console.log('Renovaciones->',this.Renovaciones);
    }); 
  }

  traerProblemas(distribuidor){
    let path = '/x/problemas/'+distribuidor

   // console.log('PATH=>',path)

    this.firestore.collection(path, ref => ref.where('disponibles', '>', 0 )).snapshotChanges().subscribe(async data=>{
      this.serviciosProblemas = [];
        data.forEach((element: any) => {
          this.serviciosProblemas.push({
            id: element.payload.doc.id,
            ...element.payload.doc.data()
          })
         })
    //  console.log('Problemas ->',this.serviciosProblemas);
    })
  }

  traerReferidos(userUid: string){
    const path = 'users/'+ userUid + '/referidos'

      this.firestore.collection(path, ref=>ref.orderBy('fecha','desc').limit(60)).get().toPromise().then((querySnapshot) => {
        this.referidos=[]
           querySnapshot.forEach((doc) => {
             this.referidos.push(
                doc.data()
             )
           });
     // console.log('Referidos', this.referidos)
      })
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////NOTIFICACION PARA COMPUTADOR////////////
  NotificationPC(servicio){

const servicioEliminado = this.notificacionantes.find((elemento) => !servicio.includes(elemento));

    if (Notification.permission !== "granted") {
      Notification.requestPermission();
      }
       else{
      var notification = new Notification('Servicio Disponible', {
        body: "Ya está disponible el servicio "+servicioEliminado.toUpperCase()+" que estabas esperando",
        icon:'../../../assets/logo/logo.png'
      });
        notification.onclick = function () {
          window.open("https://streamyapp.info/");
        };
      }
   }


   

}
